"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaPolygonWrapper$ = exports.AreaPolygonWrapper$outboundSchema = exports.AreaPolygonWrapper$inboundSchema = void 0;
exports.areaPolygonWrapperToJSON = areaPolygonWrapperToJSON;
exports.areaPolygonWrapperFromJSON = areaPolygonWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const areapolygon_js_1 = require("./areapolygon.js");
/** @internal */
exports.AreaPolygonWrapper$inboundSchema = z.object({
    attributes: areapolygon_js_1.AreaPolygon$inboundSchema,
    id: z.string(),
    type: z.literal("polygon").default("polygon").optional(),
});
/** @internal */
exports.AreaPolygonWrapper$outboundSchema = z.object({
    attributes: areapolygon_js_1.AreaPolygon$outboundSchema,
    id: z.string(),
    type: z.literal("polygon").default("polygon"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaPolygonWrapper$;
(function (AreaPolygonWrapper$) {
    /** @deprecated use `AreaPolygonWrapper$inboundSchema` instead. */
    AreaPolygonWrapper$.inboundSchema = exports.AreaPolygonWrapper$inboundSchema;
    /** @deprecated use `AreaPolygonWrapper$outboundSchema` instead. */
    AreaPolygonWrapper$.outboundSchema = exports.AreaPolygonWrapper$outboundSchema;
})(AreaPolygonWrapper$ || (exports.AreaPolygonWrapper$ = AreaPolygonWrapper$ = {}));
function areaPolygonWrapperToJSON(areaPolygonWrapper) {
    return JSON.stringify(exports.AreaPolygonWrapper$outboundSchema.parse(areaPolygonWrapper));
}
function areaPolygonWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaPolygonWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaPolygonWrapper' from JSON`);
}
//# sourceMappingURL=areapolygonwrapper.js.map